<template>
    <b-card v-if="work">
        <b-card-title>
            <b-button @click="editMode=!editMode">Ändra</b-button>
            <b-col>{{ work.InboxId }}:{{ work.InboxName }}</b-col>    
        </b-card-title>
        <b-card-body>
            <b-row>
                <b-col>
                    <label>Instans:</label><br>                    
                    <lformselect v-model="work.ClientId" :options="instances" :readonly="!editMode"></lformselect>                  
                </b-col>
                <b-col>
                    <label>Typ:</label><br>
                    {{ work.Type }}
                </b-col>
            </b-row>
            <b-row v-if="work.Type !='Always' ">
                <b-col>
                    <label>Inbox</label><br>
                    <b-form-input v-model="work.Inbox1" :readonly="!editMode"></b-form-input>                    
                </b-col>
                <b-col>
                    <label>Failed</label><br>
                    <b-form-input v-model="work.Failed" :readonly="!editMode"></b-form-input>
                </b-col>
                <b-col>
                    <label>Handled</label><br>
                    <b-form-input v-model="work.Handled" :readonly="!editMode"></b-form-input>
                </b-col>
                
            </b-row>
            <b-row>
                <b-col>
                    <b-card v-for="(cmd,i) in getCommands(inbox.Action)" :key="i">
                        <b-card-title>
                            
                        </b-card-title>
                        <b-card-body>
                            <code>{{ cmd }}</code>
                            <inboxargs :args="getCommandParams(cmd)" :editMode="editMode" :clientId="work.ClientId"></inboxargs>
                
                        </b-card-body>
                    </b-card>
                </b-col>
                <!-- <b-col>
                    <inboxargs :args="getCommandParams()" :editMode="editMode" :clientId="work.ClientId"></inboxargs>
                </b-col> -->
            </b-row>
            <b-row>
               
            </b-row>
        </b-card-body>
    </b-card>
</template>
<script>
import { Api } from "../../lib/api";
const api = new Api();

import lformselect from "@/components/l-form-select.vue"
import inboxargs from './inboxargs.vue';

export default {
    name: 'inboxdetails',
    props: {
        inbox: Object,
        instances: Array,
    },
    components: {lformselect, inboxargs},
    data() {
        return {
            work: null,
            editMode:false,
            descriptions:null,
        }
    },
    created() {
        this.setWork(this.inbox);
    },
    watch: {
        inbox: function (newval,oldval) {
            this.setWork(this.inbox);
        }
    },
    methods: {
        setWork() {
            this.work = JSON.parse(JSON.stringify(this.inbox));
            let clientId=this.work.ClientId;
            let commands = this.getCommands(this.work.Action);

            // this.descriptions=[];
            // commands.forEach(x=> {
            //     let cmdName = this.getCommandParams(x)[0];
            //     api.get(`api/inbox/GetDescription?clientId=${clientId}&commandName=${cmdName}`).then(res => {
            //         this.descriptions[cmdName]=res.data;
            //     });
            // });            
        },
        getCommands(cmd) {
            return cmd.split(';')
        },
        getCommandParams(cmd) {
            return cmd.split(',');
        }
    }
}

</script>